import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Este servicio sirve como base para poder acceder al httpClient
 */
@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private baseUri: string;

  constructor(private http: HttpClient) {}

  set uri(uri: string) {
    this.baseUri = uri;
  }

  execGetJson(headers?: HttpHeaders, data?: any): Observable<any> {
    return this.http
      .get<any>(this.baseUri, {
        observe: 'response'
      })
      .pipe(map(response => response.body));
  }

  execGetBlob(headers: HttpHeaders) {
    return this.http
      .get<any>(this.baseUri, {
        headers,
        observe: 'response',
        responseType: 'blob' as 'json'
      })
      .pipe(map(response => response.body));
  }

  execPostJson(data?: any, headers?: HttpHeaders): Observable<any> {
    return this.http
      .post(this.baseUri, data, { headers, observe: 'response' })
      .pipe(map(response => response.body));
  }

  execPutJson(data?: any, headers?: HttpHeaders): Observable<any> {
    return this.http
      .put(this.baseUri, data, { headers, observe: 'response' })
      .pipe(map(response => response.body));
  }

  execDeleteJson(body?: any, headers?: HttpHeaders): Observable<any> {
    const options = { headers, body };
    return this.http.delete(this.baseUri, options);
  }
}
